import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=66f0044a&"
import script from "./Assets.vue?vue&type=script&lang=js&"
export * from "./Assets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports